import { InvoiceStatus } from '@shared/graphql'

import { Default, Paid, Processing } from './variants'

export interface PayInvoiceProps {
  /**
   * The variant of the header that should be rendered.
   */
  invoiceStatus?: InvoiceStatus
  /**
   * Invoice ID.
   */
  invoiceId: string
}

export const PayInvoiceHeader: React.FC<PayInvoiceProps> = ({
  invoiceStatus,
  invoiceId,
}) => {
  if (invoiceStatus === InvoiceStatus.paid) {
    return <Paid invoiceId={invoiceId} />
  }

  if (invoiceStatus === InvoiceStatus.pending) {
    return <Processing />
  }

  return <Default invoiceId={invoiceId} />
}
